import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useUser');

    return {
        CONNECTION_ERROR: t('connectionError'),
        INVITE_FAILED: t('inviteFailed'),
        SAVE_FAILED: t('saveFailed')
    };
};

export default useTranslation;
